import { useState } from 'react';

import { faPlay, faPause, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface PlaybackController {
  togglePlayPause: () => void;
  setPlaybackRate: (rate: number) => void;
  state: {
    isPlaying: boolean;
    playbackRate: number;
  };
}

interface PlaybackControlsProps {
  playbackController: PlaybackController;
}

const speedOptions = [
  { value: 0.5, label: '0.5x' },
  { value: 0.75, label: '0.75x' },
  { value: 1, label: '1x' },
  { value: 1.25, label: '1.25x' },
  { value: 1.5, label: '1.5x' },
  { value: 2, label: '2x' },
];

export const PlaybackControls = ({ playbackController }: PlaybackControlsProps) => {
  const [showSpeedDropdown, setShowSpeedDropdown] = useState(false);

  return (
    <div className="flex items-center gap-1.5">
      {/* View toggle button */}

      <button
        onClick={playbackController.togglePlayPause}
        className="flex h-8 w-8 items-center justify-center rounded-md border border-gray-300 bg-white text-gray-700 transition-colors hover:bg-gray-50"
        title={playbackController.state.isPlaying ? 'Pause' : 'Play'}
      >
        <FontAwesomeIcon icon={playbackController.state.isPlaying ? faPause : faPlay} className="ml-0.5 h-3 w-3" />
      </button>

      {/* Speed control dropdown */}
      <div className="relative">
        <button
          onClick={() => setShowSpeedDropdown(!showSpeedDropdown)}
          className="flex h-8 items-center gap-1 rounded-md border border-gray-300 bg-white px-2 text-gray-700 transition-colors hover:bg-gray-50"
          title="Playback Speed"
        >
          <span className="text-xs font-medium">
            {speedOptions.find((option) => option.value === playbackController.state.playbackRate)?.label || '1x'}
          </span>
          <FontAwesomeIcon icon={faChevronDown} className="h-2 w-2" />
        </button>

        {showSpeedDropdown && (
          <>
            {/* Backdrop */}
            <div className="fixed inset-0 z-20" onClick={() => setShowSpeedDropdown(false)} />

            {/* Dropdown */}
            <div className="absolute top-9 right-0 z-30 w-20 rounded-md border border-gray-200 bg-white shadow-lg">
              <div className="py-1">
                {speedOptions.map((option) => (
                  <button
                    key={option.value}
                    onClick={() => {
                      playbackController.setPlaybackRate(option.value);
                      setShowSpeedDropdown(false);
                    }}
                    className={`w-full px-3 py-1.5 text-left text-xs transition-colors hover:bg-gray-50 ${
                      playbackController.state.playbackRate === option.value
                        ? 'bg-slate-50 font-medium text-slate-700'
                        : 'text-gray-700'
                    }`}
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
